(function(){"use strict";function collapseEmpireNavigation(){if(!(window.innerWidth>=720)){var header=document.querySelector("[data-site-header]"),menuToggle=document.querySelector("[data-site-header] [data-menu-toggle]");header&&(header.classList.remove("site-header-nav--open"),menuToggle&&(menuToggle.classList.remove("active"),menuToggle.setAttribute("aria-expanded","false")))}}function pageNeedsPaletteNormalizer(){return!!document.querySelector(".vmat-card-media img, #viviero-colors-v8 .vcp-card-image img")}function loadBaseCustomScript(){if(!(window.__vivieroCustomBaseLoaded||window.__vivieroCustomBaseLoading)&&pageNeedsPaletteNormalizer()){window.__vivieroCustomBaseLoading=!0;var current=document.currentScript;if(current||(current=document.querySelector('script[src*="viviero-custom.js"]')),!current||!current.src){window.__vivieroCustomBaseLoading=!1;return}var source;try{source=new URL(current.src,window.location.href),source.pathname=source.pathname.replace(/viviero-custom\.js$/,"viviero-custom-base.js"),source.search=""}catch(error){window.__vivieroCustomBaseLoading=!1;return}var base=document.createElement("script");base.src=source.toString(),base.async=!1,base.onload=function(){window.__vivieroCustomBaseLoaded=!0,window.__vivieroCustomBaseLoading=!1},base.onerror=function(){window.__vivieroCustomBaseLoading=!1},document.head.appendChild(base)}}function scheduleBaseCustomScript(){pageNeedsPaletteNormalizer()&&("requestIdleCallback"in window?window.requestIdleCallback(loadBaseCustomScript,{timeout:1600}):window.setTimeout(loadBaseCustomScript,800))}scheduleBaseCustomScript(),document.readyState==="loading"?document.addEventListener("DOMContentLoaded",function(){collapseEmpireNavigation(),window.setTimeout(collapseEmpireNavigation,400)},{once:!0}):(collapseEmpireNavigation(),window.setTimeout(collapseEmpireNavigation,400)),window.addEventListener("pageshow",function(){window.setTimeout(collapseEmpireNavigation,250)})})();

/* Viviero3D order properties v5 — one writer, exact option names.
 * This replaces v2/v3/v4; do not append it after those handlers.
 * Variant selection, prices, quantities and color/custom text are not modified.
 */
(function () {
  'use strict';
  if (window.__vivieroOrderPropertiesV5) return;
  window.__vivieroOrderPropertiesV5 = true;

  var FORM = 'form[action*="/cart/add"]';
  var bound = new WeakSet();
  var pending = new Set();
  var frame = 0;
  var names = {
    use: ['use & finish', 'use and finish', 'use', 'indoor/outdoor'],
    material: ['material', 'material type', 'print material'],
    drainage: ['drainage'],
    tray: ['tray']
  };

  function normalize(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function optionName(value) {
    var result = String(value || '').replace(/\+/g, ' ');
    try { result = decodeURIComponent(result); } catch (error) { /* Preserve malformed names. */ }
    result = normalize(result);
    var match = /^options\[([^\]]+)\]$/.exec(result);
    return match ? match[1] : result;
  }
  function chosen(form, allowedNames) {
    var fields = Array.from(form.elements);
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (!field.name || field.disabled || allowedNames.indexOf(optionName(field.name)) === -1) continue;
      if ((field.type === 'radio' || field.type === 'checkbox') && !field.checked) continue;
      var value = String(field.value == null ? '' : field.value).trim();
      if (value) return value;
    }
    return '';
  }
  function materialLabel(use, material) {
    var combined = normalize(use + ' ' + material);
    if (!combined) return '';
    if (/wood[ -]?(texture|fiber|filled)|wood pla|premium wood/.test(combined)) {
      return 'Wood Fiber PLA — Indoor / Wood Texture';
    }
    if (/\basa\b|\bpetg\b|\boutdoor\b/.test(combined)) return 'ASA — Outdoor';
    if (/\bpla\b|\bindoor\b/.test(combined)) return 'PLA — Indoor';
    return material || use;
  }
  function drainageLabel(value) {
    var key = normalize(value);
    if (/^(yes|true|1|with)(\b|$)/.test(key)) return 'With Drainage Hole';
    if (/^(no|false|0|without)(\b|$)/.test(key)) return 'No Drainage Hole';
    return value;
  }
  function trayLabel(value) {
    var key = normalize(value);
    if (['yes', 'true', '1', 'pot + tray'].indexOf(key) !== -1) return 'Yes';
    if (['no', 'false', '0', 'pot only'].indexOf(key) !== -1) return 'No';
    return value;
  }
  function valuesFor(form) {
    return {
      'Material & Use': materialLabel(chosen(form, names.use), chosen(form, names.material)),
      'Drainage': drainageLabel(chosen(form, names.drainage)),
      'Tray': ''
    };
  }
  function writeProperty(form, label, value) {
    var name = 'properties[' + label + ']';
    var fields = Array.from(form.elements).filter(function (input) {
      return input.name === name && input.type === 'hidden';
    });
    if (!value) {
      fields.forEach(function (input) { if (!input.disabled) input.disabled = true; });
      return;
    }
    var input = fields[0];
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.setAttribute('data-viviero-order-property', label);
      form.appendChild(input);
    }
    if (input.disabled) input.disabled = false;
    if (input.value !== value) input.value = value;
    fields.slice(1).forEach(function (duplicate) { if (!duplicate.disabled) duplicate.disabled = true; });
  }
  function sync(form) {
    var values = valuesFor(form);
    Object.keys(values).forEach(function (label) { writeProperty(form, label, values[label]); });
    return values;
  }
  function bind(form) {
    if (!form || !form.matches || !form.matches(FORM)) return;
    if (!bound.has(form)) {
      bound.add(form);
      form.addEventListener('formdata', function (event) {
        var values = sync(form);
        Object.keys(values).forEach(function (label) {
          var key = 'properties[' + label + ']';
          if (values[label]) event.formData.set(key, values[label]);
          else event.formData.delete(key);
        });
      });
    }
    sync(form);
  }
  function queue(form) {
    if (!form || !form.matches || !form.matches(FORM)) return;
    pending.add(form);
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      var forms = Array.from(pending);
      pending.clear();
      forms.forEach(function (item) { if (item.isConnected) bind(item); });
    });
  }
  function eventForm(event) {
    var target = event.target;
    if (!target) return null;
    return target.form || (target.closest ? target.closest(FORM) : null);
  }
  ['input', 'change', 'click', 'submit'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var form = eventForm(event);
      if (!form || !form.matches(FORM)) return;
      bind(form); // Before Empire serializes the form on click/submit.
      if (type !== 'submit') queue(form); // Reconcile after native option handlers.
    }, true);
  });
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.matches(FORM)) queue(node);
    node.querySelectorAll(FORM).forEach(queue);
  }
  function start() {
    var forms = document.querySelectorAll(FORM);
    if (!forms.length) return;
    forms.forEach(bind);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          // Our hidden fields and color properties must not produce feedback loops.
          if (node.matches('input[type="hidden"][name^="properties["]')) return;
          scan(node);
          if (node.matches('input, select, textarea') || node.querySelector('input, select, textarea')) {
            queue(node.form || (node.closest && node.closest(FORM)));
          }
        });
      });
    });
    observer.observe(document.documentElement, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
  window.addEventListener('pageshow', function () { document.querySelectorAll(FORM).forEach(bind); });
})();

